<!-- Client creation form -->
<form [formGroup]="form" (ngSubmit)="createNew()">
    <div>
        <label for="name">Name:</label>
        <input type="text" id="name" formControlName="name">
    </div>
    <div>
        <label for="description">Description:</label>
        <input type="text" id="description" formControlName="description">
    </div>
    <button type="submit">Create Client</button>
</form>
<div *ngIf="id">Created Client ID: {{ id }}</div>

<!-- Show all clients toggle -->
<button (click)="toggleShowClients()">
    {{ showClients ? 'Hide Clients' : 'Show All Clients'}}
</button>

<!-- Table shows all clients with controls for update and delete -->
<table *ngIf="showClients">
    <thead>
        <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Description</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let client of clients; let i = index">
            <td>{{ client.id }}</td>
            <td>
                <input *ngIf="client.isEditing" type="text" [(ngModel)]="client.name">
                <span *ngIf="!client.isEditing">{{client.name}}</span>
            </td>
            <td>
                <input *ngIf="client.isEditing" type="text" [(ngModel)]="client.description">
                <span *ngIf="!client.isEditing">{{client.description}}</span>
            </td>
            <td>
                <button *ngIf="!client.isEditing" (click)="editClient(client)">Edit</button>
                <button *ngIf="client.isEditing" (click)="updateClient(client)">Save</button>
                <button *ngIf="client.isEditing" (click)="cancelEditing(client)">Cancel</button>
                <button (click)="deleteClient(client.id)">Delete</button>
            </td>
        </tr>
    </tbody>
</table>